<template>
  <div class="container mt-5 text-center">
    <h3>Chat</h3>
    <div v-if="loading" class="spinner-border mt-2" role="status">
      <span  class="sr-only">Loading...</span>
    </div>
    <div class="container">
      <h3>En Construcción...</h3>
      <!-- <div class="">
        <ul class="list-group">
          <template v-for="item of items" >
          <li v-if="user.numero != ude" class="list-group-item text-left" :key="item.id">{{item.mensaje}}</li>
          <li v-if="user.numero == ude" class="list-group-item text-right" :key="item.id">{{item.mensaje}}</li>
          </template>
        </ul>
      </div>
      <div id="copyright" >
        <div class="row text-center">
          <div class="col-md-8">
            <input type="text" style="width:70% !important" v-model="message" name="" id="">
          </div>
          <div class="col-md-4">
          <button class="btn btn-primary" @click="sendMessage()">Enviar</button>
          </div>
        </div>
      </div>
       -->
    </div>
  </div>
</template>

<script>
  import SimpleModal from 'simple-modal-vue'
  import api from "../config/api";
  export default {
    components: { SimpleModal },
    data(){
      return{
        items:[],
        user: null,
        loading: false,
        isShow: false,
        row:{},
        message: ''
      }
    },
    async mounted() {
      //solo mostramos mensajes no leidos
      //aca en  mounted marcar todos los mensajes como leidos, para que la proxima vez no pueda verlos
      //despues de marcar como leidos no recargamos datos
      this.$isLoading(true)
      this.user = JSON.parse(localStorage.getItem('user'));
      console.log('-->', this.user)
      await this.getData()
      this.$isLoading(false)
    },
    methods:{
      async sendMessage(){
        console.log('init sendMesage')
        try {
          let data = {
            ude: + this.user.numero,
            para: "1",
            mensaje: this.message,
            leido: 0,
            origen: "app-servi99"
          }
          let resultv = await api.request("post", '/BMGES_insertarChat/', data);
          let res = resultv.data;
          this.items = res;
          alert('enviado')
          console.log('mensajes', resultv);
          
        } catch (error) {
          console.log(error)
          return;
        }
      },
      showModal(item){
        this.row = item
        this.isShow= true
      },
      async getData(){
        let resultv = await api.request("get", '/BMGES_historialchat/' + this.user.numero);
        let res = resultv.data
        this.items = res
        console.log('mensajes', resultv)
      }
    }
  }
</script>

<style>
#container {
  position: relative;
}
#copyright {
  position: absolute;
  bottom: 0;
}
</style>